import * as React from "react";
const SvgFiRrGrinTears = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-grin-tears_svg__a)">
      <path
        fill="#062147"
        d="M.071 10.685c1.85-14.163 22.014-14.153 23.858 0a1 1 0 1 1-1.989.217C20.4-.9 3.6-.89 2.06 10.9a1 1 0 1 1-1.989-.217zm18.63 8.736a10.05 10.05 0 0 1-13.4 0 1 1 0 0 0-1.414.072 1 1 0 0 0 .072 1.413 12.063 12.063 0 0 0 16.086 0 1 1 0 1 0-1.34-1.485zM7 11c0-1.054.678-2 1-2 .32 0 1 .946 1 2a1 1 0 1 0 2 0c0-1.892-1.233-4-3-4-1.769 0-3 2.108-3 4a1 1 0 1 0 2 0m12 0c-.249-5.285-5.754-5.282-6 0a1 1 0 1 0 2 0c0-1.054.68-2 1-2s1 .946 1 2a1 1 0 1 0 2 0m-7 8a6.83 6.83 0 0 0 5.841-3.458 1 1 0 0 0-1.053-1.518c-1.534.578-3.15.908-4.789.976a15.4 15.4 0 0 1-4.8-.976 1 1 0 0 0-1.052 1.518A6.84 6.84 0 0 0 12 19m11.38-4.613A6.96 6.96 0 0 0 19.693 13a.637.637 0 0 0-.686.69c.125 2.139 1.7 5.846 4.372 3.688a2.115 2.115 0 0 0 0-2.991M4.305 13C2.2 13.1-1.549 14.736.62 17.38c2.673 2.159 4.247-1.552 4.372-3.687A.637.637 0 0 0 4.306 13"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-grin-tears_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrGrinTears;
